import React , { useState , useEffect } from "react";
import { Row, Col, Container, Input, Card, CardBody, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';


function Group_Token_Allocation_List({ group , group_token_allocation_list_for_update , set_group_token_allocation_list_for_update }) {
  const {
    Group_Name,
    Token_Allowed,
    Token_Balance,
    Token_Used,
    User_Group_ID,
    User_Role,
    Group_ID,
  } = group;
   
const [group_token_allocation_obj, set_group_token_allocation_obj] = useState({
    Group_ID,
    Token_Allowed
})

useEffect(() => {
   set_group_token_allocation_obj({
    Group_ID,
    Token_Allowed
   })
   
}, [group])

const onChange_Group_Token_Allocation = (e) => {
    // Remove commas and parse the input value
    const inputValue = parseInt(e.target.value.replace(/,/g, ""), 10);

    // Validate input: ensure it is a number or empty
    if (isNaN(inputValue)) {
      return;
    }

    let temp_token_group_allocation_list = [...group_token_allocation_list_for_update];
    let updated = false;

    // Update the token allocation list
    temp_token_group_allocation_list = temp_token_group_allocation_list.map((element) => {
      if (element.Group_ID === Group_ID) {
        updated = true;
        return {
          Group_ID,
          Token_Allowed: inputValue,
        };
      }
      return element;
    });

    // If no update occurred, add a new entry
    if (!updated) {
      temp_token_group_allocation_list.push({ Group_ID, Token_Allowed: inputValue });
    }

    // Update states
    set_group_token_allocation_list_for_update(temp_token_group_allocation_list);
    set_group_token_allocation_obj({ Group_ID, Token_Allowed: inputValue });
  };


  return (
    <tr key={User_Group_ID || i}>
      <td
        style={{ cursor: "pointer" }}
        onClick={() => {
          navigate("/Group_Dashboard", {
            state: {
              Group_ID,
            },
          });
        }}
        className="group_name"
      >
        {Group_Name}
      </td>
      <td className="Monthly limit">
        <Input
          disabled={false}
          htmlFor="Monthly limit"
          placeholder={Token_Allowed.toLocaleString()}
          value={group_token_allocation_obj.Token_Allowed.toLocaleString()}
          onChange={onChange_Group_Token_Allocation}
          style={{ textAlign: "right" }}
        />
      </td>
      <td className="edit_view" style={{ textAlign: "right" }}>
        {Token_Balance.toLocaleString()}
      </td>
    </tr>
  );
}

export default Group_Token_Allocation_List;
